/* eslint-disable react/prop-types */
import React from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function EquipmentLedgerInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { details = [] } = values;

  const handleChangeField = (path, val) => {
    setFieldValue(path, val);
  };

  const handleChangeTable = (index, field, val) => {
    const newDetails = [...details];
    newDetails[index][field] = val;

    // Tự động tính cột 3 = 1 * 2 (Thành tiền ghi tăng)
    if (field === "quantity" || field === "unitPrice") {
      const q = parseFloat(newDetails[index].quantity) || 0;
      const p = parseFloat(newDetails[index].unitPrice) || 0;
      newDetails[index].amount = q * p;
    }

    setFieldValue("details", newDetails);
  };

  const addRow = () => {
    const template = {
      increaseDocNumber: "",
      increaseDocDate: "",
      assetName: "",
      unit: "",
      quantity: 0,
      unitPrice: 0,
      amount: 0,
      decreaseDocNumber: "",
      decreaseDocDate: "",
      decreaseReason: "",
      decreaseQuantity: 0,
      decreaseAmount: 0,
      note: "",
    };
    setFieldValue("details", [...details, template]);
  };

  const removeRow = (index) => {
    if (details.length <= 1) return;
    setFieldValue("details", details.filter((_, i) => i !== index));
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "13px", lineHeight: "1.5" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "10px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "13px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "13px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "12px", marginTop: "10px", marginBottom: "15px" },
    th: { border: "1px solid #000", padding: "4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#fff" },
    td: { border: "1px solid #000", padding: 0, height: "30px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "14px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "5px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "40%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "60%" }}>
          <div style={{ fontWeight: "bold", fontSize: "14px" }}>Mẫu số S22-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "16px" }}>SỔ THEO DÕI TÀI SẢN CỐ ĐỊNH VÀ CÔNG CỤ, DỤNG CỤ TẠI NƠI SỬ DỤNG</h2>
        <div style={{ marginTop: 5, fontWeight: "bold" }}>
          Năm: <input disabled={containView} style={{ ...s.inputDotted, width: "80px", textAlign: "center" }} value={values.year} onChange={(e) => handleChangeField("year", e.target.value)} />
        </div>
        <div style={{ marginTop: 5 }}>
          Tên đơn vị (phòng, ban hoặc người sử dụng): <input disabled={containView} style={{ ...s.inputDotted, width: "300px" }} value={values.userDepartment} onChange={(e) => handleChangeField("userDepartment", e.target.value)} />
        </div>
      </div>

      {/* TABLE 14 COLUMNS */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th} colSpan={7}>Ghi tăng tài sản cố định và công cụ, dụng cụ</th>
              <th style={s.th} colSpan={5}>Ghi giảm tài sản cố định và công cụ, dụng cụ</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Ghi chú</th>
              {!containView && <th style={{ ...s.th, width: "30px" }} rowSpan={3}>#</th>}
            </tr>
            <tr>
              <th style={s.th} colSpan={2}>Chứng từ</th>
              <th style={s.th} rowSpan={2}>Tên, nhãn hiệu, quy cách tài sản cố định và công cụ, dụng cụ</th>
              <th style={{ ...s.th, width: "50px" }} rowSpan={2}>Đơn vị tính</th>
              <th style={{ ...s.th, width: "60px" }} rowSpan={2}>Số lượng</th>
              <th style={{ ...s.th, width: "80px" }} rowSpan={2}>Đơn giá</th>
              <th style={{ ...s.th, width: "90px" }} rowSpan={2}>Số tiền</th>
              
              <th style={s.th} colSpan={2}>Chứng từ</th>
              <th style={s.th} rowSpan={2}>Lý do</th>
              <th style={{ ...s.th, width: "60px" }} rowSpan={2}>Số lượng</th>
              <th style={{ ...s.th, width: "90px" }} rowSpan={2}>Số tiền</th>
            </tr>
            <tr>
              <th style={{ ...s.th, width: "60px" }}>Số hiệu</th>
              <th style={{ ...s.th, width: "70px" }}>Ngày, tháng</th>
              <th style={{ ...s.th, width: "60px" }}>Số hiệu</th>
              <th style={{ ...s.th, width: "70px" }}>Ngày, tháng</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>D</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3=1x2</th>
              <th style={s.th}>E</th>
              <th style={s.th}>G</th>
              <th style={s.th}>H</th>
              <th style={s.th}>4</th>
              <th style={s.th}>5</th>
              <th style={s.th}>I</th>
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {details.map((item, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.increaseDocNumber} onChange={(e) => handleChangeTable(idx, "increaseDocNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.increaseDocDate} onChange={(e) => handleChangeTable(idx, "increaseDocDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.assetName} onChange={(e) => handleChangeTable(idx, "assetName", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.unit} onChange={(e) => handleChangeTable(idx, "unit", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableCenter} value={item.quantity} onChange={(e) => handleChangeTable(idx, "quantity", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.unitPrice} onChange={(e) => handleChangeTable(idx, "unitPrice", e.target.value)} /></td>
                <td style={s.td}><input disabled style={s.inputTableRight} value={fmt(item.amount)} /></td>
                
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.decreaseDocNumber} onChange={(e) => handleChangeTable(idx, "decreaseDocNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.decreaseDocDate} onChange={(e) => handleChangeTable(idx, "decreaseDocDate", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.decreaseReason} onChange={(e) => handleChangeTable(idx, "decreaseReason", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableCenter} value={item.decreaseQuantity} onChange={(e) => handleChangeTable(idx, "decreaseQuantity", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.decreaseAmount} onChange={(e) => handleChangeTable(idx, "decreaseAmount", e.target.value)} /></td>
                
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.note} onChange={(e) => handleChangeTable(idx, "note", e.target.value)} /></td>
                
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>–</button></td>}
              </tr>
            ))}
          </tbody>
        </table>
        {!containView && (
          <SoftBox textAlign="center" mb={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm nghiệp vụ</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER: INFO */}
      <div style={{ marginTop: "15px" }}>
        <div style={s.rowLabel}>- Sổ này có <input disabled={containView} style={s.inputDottedSmall} value={values.totalPages} onChange={(e) => handleChangeField("totalPages", e.target.value)} /> trang, đánh số từ trang 01 đến trang...</div>
        <div style={s.rowLabel}>- Ngày mở sổ: <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.openingDate} onChange={(e) => handleChangeField("openingDate", e.target.value)} /></div>
      </div>

      {/* FOOTER: SIGNATURES */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên)</div>
          <SoftBox mt={6}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên)</div>
          <SoftBox mt={6}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "12px", marginBottom: "5px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={6}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} />
          </SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
